import React, { FC, useState } from 'react';
import styles from './styles.module.css';
import { Button, Dropdown, MenuProps } from 'antd';
import { ExternalLink } from 'lucide-react';
import * as translations from '../../strings';
import { getLangKey } from 'appJS/models/Language';
import { getProjectSiteViewUrl } from 'appJS/utils/getProjectSiteViewUrl';

type Props = {
  projectId: number | string;
  projectSites: {
    url: string;
    id: number;
  }[];
  container: HTMLDivElement;
  isMobileView: boolean;
  isReviewApp: boolean;
  isAdminUser: boolean;
  apiKey: string;
};

const strings = translations[getLangKey()];

const truncateUrl = (url: string, maxLength: number = 50): string => {
  if (url.length <= maxLength) {
    return url;
  }
  return url.substring(0, maxLength - 3) + '...';
};

export const OpenWebsite: FC<Props> = ({
  projectId,
  projectSites,
  container,
  isMobileView,
  isReviewApp,
  apiKey,
  isAdminUser
}) => {
  const [sitesMenuOpen, setSitesMenuOpen] = useState<boolean>(false);

  const items: MenuProps['items'] = projectSites.map(site => {
    const isTruncated = site.url.length > 50;
    const viewUrl = getProjectSiteViewUrl(projectId, site.id);
    return {
      label: isTruncated ? (
        <div className={styles.tickerContainer}>
          <div className={styles.tickerStatic}>
            <a href={viewUrl} target="_blank" className={styles.urlLink}>
              {truncateUrl(site.url)}
            </a>
          </div>
          <div className={styles.tickerContent}>
            <a href={viewUrl} target="_blank" className={styles.urlLink}>
              {site.url}
            </a>
          </div>
        </div>
      ) : (
        <a href={viewUrl} target="_blank" className={styles.urlLink}>
          {site.url}
        </a>
      ),
      key: site.id
    };
  });

  const OpenWebsiteButton = props => (
    <Button
      type="link"
      className={styles.openWebsite}
      icon={<ExternalLink className={styles.websiteIcon} />}
      title={strings.openWebsite}
      onClick={event => {
        event.stopPropagation();
        event.preventDefault();
        if (!projectSites[0]) return;
        window.open(
          getProjectSiteViewUrl(projectId, projectSites[0].id),
          '_blank'
        );
      }}
      {...props}
    >
      {!isMobileView && strings.openWebsite}
    </Button>
  );

  if (isReviewApp || isAdminUser) {
    items.push({
      label: (
        <a href={`/test/widget?apikey=${apiKey}`} target="_blank">
          test project sidebar
        </a>
      ),
      key: 'test'
    });
  }

  if (projectSites.length > 1 || isAdminUser) {
    return (
      <Dropdown
        className={styles.sitesDropdown}
        placement="bottomRight"
        menu={{ items }}
        trigger={['hover']}
        getPopupContainer={() => container}
        open={sitesMenuOpen}
        onOpenChange={setSitesMenuOpen}
      >
        <OpenWebsiteButton />
      </Dropdown>
    );
  } else if (projectSites.length === 1) {
    return <OpenWebsiteButton />;
  }
  return null;
};
